export function joinRadio(){
    document.querySelectorAll('.iAM .gchoice input[type="radio"]').forEach(function (radio) { 
        // Find Radio that is Checked add Class
        if (radio.checked == true) {
            radio.parentElement.classList.toggle('checked')
        }
        // On Click Toggle Class
        radio.addEventListener("click", event => {
            //console.log(event)
            document.querySelector('.iAM .gchoice.checked').classList.remove('checked');
            radio.parentElement.classList.toggle('checked')      
        })
    })
}